module.exports = __webpack_public_path__ + "static/media/atuacao.3362dc0a.svg";